import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import './index.scss'
import App from './pages/base/App'
import reportWebVitals from './reportWebVitals'
import configureStore from './redux/middleware/configureStore'
import RecaptchaWrapper from './components/global/RecaptchaWrapper'

const root = ReactDOM.createRoot(document.getElementById('root'))
import * as atatus from 'atatus-spa'
atatus.config('bb4f6ff5acfc41188d9df67f719108d5').install()
root.render(
	// <React.StrictMode>
		<Provider store={configureStore()}>
			<RecaptchaWrapper>
				<App />
			</RecaptchaWrapper>
		</Provider>
	// </React.StrictMode>
)
reportWebVitals()
